import OrganisationDetailsPage from '@/pages/vendor/onboarding/organisation-details/OrganisationDetailsPage.vue';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    components: {
        OrganisationDetailsPage
    }
});
